/**
 * Paleta de colores extendida basada en el sistema de diseño
 * Colores base del proyecto:
 * - Primary (verde): #55ac4b
 * - Secondary (naranja): #f09c2b
 * - Accent (azul): #005CAF
 * - Success (verde claro): #5ed52b
 * - Error (rojo): #f42b17
 * - Warning (amarillo): #FFB74C
 * - Info (gris): #606560
 */

export const CHART_COLORS = {
	// Colores base del sistema
	primary: '#55ac4b',
	secondary: '#f09c2b',
	accent: '#005CAF',
	success: '#5ed52b',
	error: '#f42b17',
	warning: '#FFB74C',
	info: '#606560',

	// Paleta para distribuciones (5 tonos)
	distribution: [
		'#55ac4b', // Alto desempeño
		'#5ed52b', // Buen desempeño
		'#FFB74C', // Desempeño medio
		'#f09c2b', // Necesita mejora
		'#f42b17', // Crítico
	],

	// Paleta para múltiples series (10 tonos)
	multiSeries: [
		'#55ac4b', '#005CAF', '#f09c2b', '#5ed52b', '#f42b17',
		'#8b5cf6', '#06b6d4', '#ec4899', '#f97316', '#14b8a6',
	],

	// Paleta para box plots
	boxPlot: {
		upper: '#55ac4b',
		lower: '#005CAF',
	},
};

/**
 * Obtiene color según puntuación (0-100)
 * @param {number} score - Puntuación de 0 a 100
 * @returns {string} Color hexadecimal correspondiente
 */
export function getColorForScore(score) {
	if (score >= 85) return CHART_COLORS.success;
	if (score >= 75) return '#5ed52b';
	if (score >= 60) return CHART_COLORS.secondary;
	if (score >= 40) return CHART_COLORS.warning;
	return CHART_COLORS.error;
}

/**
 * Genera paleta de colores para treemap
 * @param {number} count - Número de colores a generar
 * @returns {string[]} Array de colores hexadecimales
 */
export function generateTreemapColors(count) {
	const colors = [];
	for (let i = 0; i < count; i += 1) {
		const idx = i % CHART_COLORS.multiSeries.length;
		colors.push(CHART_COLORS.multiSeries[idx]);
	}
	return colors;
}

/**
 * Obtiene color para estado de alternativa
 * @param {string} alternative - Nombre de la alternativa
 * @returns {string} Color hexadecimal correspondiente
 */
export function getColorForAlternative(alternative) {
	const colors = {
		'Muy desarrollado': CHART_COLORS.success,
		Desarrollado: CHART_COLORS.primary,
		'Medianamente desarrollado': CHART_COLORS.secondary,
		'Poco desarrollado': CHART_COLORS.warning,
		'Poco Desarrollado': CHART_COLORS.warning,
		default: CHART_COLORS.info,
	};
	return colors[alternative] || colors.default;
}



// WEBPACK FOOTER //
// ./src/shared/chart-colors.js